import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'

export function fieldIsRelationship(column: SchemaColumn, fields: SchemaField[]): boolean {
  return fields.find((item) => item.name === column.accessorKey)?.type === 'relationship'
}
